module.exports = __webpack_public_path__ + "img/deskshelf11.54b57e67.jpg";